module.exports = __webpack_public_path__ + "img/p_13.c293de8c.png";